import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=632c1b65&scoped=true&"
import script from "./VueAudio.vue?vue&type=script&lang=js&"
export * from "./VueAudio.vue?vue&type=script&lang=js&"
import style0 from "./VueAudio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VueAudio.vue?vue&type=style&index=1&id=632c1b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c1b65",
  null
  
)

export default component.exports